export default __webpack_public_path__ + "static/media/five.6f52d124.jpeg";